const decorateQueryInText = ({
  decorateQuery = (string) => string,
  decorateText = (string) => string,
  query,
  text
}) => {
  if (!text || !query)
    return text;
  const queryLowercase = query.toLowerCase();
  let location = text.toLowerCase().indexOf(queryLowercase);
  let fragment = text;
  let parts = Array(0);
  let uniqueKey = 0;
  if (location === -1)
    return text;
  while (location > -1) {
    uniqueKey = parts.length;
    if (location === 0)
      parts.push(
        decorateQuery(fragment.slice(location, query.length), uniqueKey)
        // matched part
      );
    else if (location > 0) {
      parts = parts.concat([
        decorateText(
          fragment.slice(0, location),
          // unmatched part
          uniqueKey
        ),
        decorateQuery(
          fragment.slice(location, location + query.length),
          // matched part
          uniqueKey + 1
        )
      ]);
    }
    fragment = fragment.slice(location + query.length);
    location = fragment.toLowerCase().indexOf(queryLowercase);
    if (location === -1 && fragment.length > 0) {
      parts.push(decorateText(fragment, uniqueKey + 2));
    }
  }
  return parts;
};

export { decorateQueryInText as default };
